import { Box } from 'theme-ui'

import Type from 'src/components/gel/Type'

export interface Detail {
  label: string
  value: string
}

const orderDetails = (details: Detail[]) => {
  const sectionOrder = [
    'Platform',
    'Device',
    'Targeting',
    'Deal Type',
    'Ad Slot',
    'Ad Format',
    'Ad Placement',
    'Video',
    'Responsive',
    'Center Break',
    'End Break',
    'Genre',
    'Programme',
    'Channel',
    'Content Bundle',
    'Date & Time',
    'Frequency Capping'
  ]
  const orderedDetails: Detail[] = []

  details.map(d => {
    if (sectionOrder.includes(d.label) && d.value) orderedDetails[sectionOrder.indexOf(d.label)] = d
  })

  return orderedDetails
}

const DetailsSection = ({ details }: { details: Detail[] }) => {
  const orderedDetails = orderDetails(details)
  return (
    orderedDetails.length > 0 && (
      <Box sx={{ py: [6, 6, 6, 11], px: [4], height: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            height: 'auto'
          }}
        >
          <Box
            sx={{
              width: ['100%', '100%', '100%', 'calc(37.5% - 16px)']
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                height: ['auto'],
                pt: [5, null, 5, 0],
                pb: [5, null, 5, 0]
              }}
            >
              <Type variant="SectionTitleSans">{'Detailed Info'}</Type>
            </Box>
          </Box>
          <Box
            sx={{
              width: ['100%', '100%', '100%', 'calc(62.5% + 16px)'],
              display: 'block',
              height: ['auto']
            }}
          >
            {orderedDetails.map((detail, idx) => {
              return (
                <Box
                  key={idx}
                  sx={{
                    height: 'auto',
                    borderBottom: '1.5px solid #9E9E9E',
                    display: 'flex',
                    py: [2, 2, 2, 4]
                  }}
                >
                  <Box
                    sx={{
                      height: 'auto',
                      width: ['100%', '100%', '100%', 'calc(37.5% - 16px)']
                    }}
                  >
                    <Type variant="BodyEmphasised">{detail.label}</Type>
                  </Box>
                  <Box
                    sx={{
                      width: ['100%', '100%', '100%', 'calc(62.5% + 16px)']
                    }}
                  >
                    <Type variant="Body">{detail.value}</Type>
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    )
  )
}

export default DetailsSection
